<app-alert></app-alert>
<section class="card">
    <div class="card-header" style="color: black; font-size:20px;" >
        <span class="cat_core_title">
            <p><strong id="pageTitle">MGT-2 Register of Debenture holders / other securities holders </strong></p>
        </span>
        <span style="float: right">
            <!-- <a routerLink="/mgt2-list"> -->
              <button (click)="backMGT2()" class="btn btn-sm btn-default pull-right btn-back" type="button">
              <i class=" fa fa-chevron-circle-left"></i>&nbsp;Back</button>
            <!-- </a>     -->
        </span>
        <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictmgt2TabFlag">
            <span>
              <i class="fa fa-save"></i>&nbsp;Generate Output</span>
          </button>
    </span>
    </div>



  <div class="row">
    <div class="col-lg-12" id="directorTabContainer">
      <div class="vavTabs">
        <ul class="nav nav-tabs " role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#typesOfSecurities" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}" role="tab">
              Type of Securities
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" *ngIf="restrictmgt2TabFlag" href="javascript: void(0);" data-toggle="tab" data-target="#personalDetails" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}" role="tab">
              Personal Details
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" *ngIf="restrictmgt2TabFlag" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfHolding " [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}" role="tab">
              Details of Holdings
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" *ngIf="restrictmgt2TabFlag" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfSecurity " role="tab" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}" role="tab">
              Details Of Security
            </a>
          </li>
        </ul>
      </div>
      <div class="tab-content" >
        <!-- types of securities -->
        <div class="tab-pane active" id="typesOfSecurities" role="tabcard">
          <div class="modal-body">

            <div class="form-group col-sm-6 col-lg-12" >
              <!-- <div  class="row" > -->
              <form [formGroup]='secForm'> 
                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Select Types</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select _ngcontent-c2="" class="form-control" (change)="securityOnChange($event.target.value)" [formControl]="secForm.controls['selectTypes']" style="padding:6px;">                                                                                    
                    <option _ngcontent-c2="" value="null" [selected]="true" >Select  Type </option>
                    <option _ngcontent-c2="" value="debentures">Debentures </option>
                    <option _ngcontent-c2="" value="otherssecurities">Other Securities (Specify)</option>                                                            
                    <div *ngIf="secForm.controls['selectTypes'].hasError('required') && secForm.controls['selectTypes'].touched" class="form-control-error-custom">
                        Selection is required.
                    </div>
                    </select>                                             
                  </div>
                                          
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Nominal value per unit (in Rs.) </label>
                      <input type="text" class="form-control" [formControl]="secForm.controls['nominalValue']">
                      <div *ngIf="secForm.controls['nominalValue'].hasError('pattern') || secForm.controls['nominalValue'].hasError('maxlength')" class="form-control-error-custom">
                        Nominal value per unit is invalid.
                      </div> 
                    </div>
                  </div>
                                                              
                  <div class="row">
                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Total no. of debentures / other securities held</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" 
                    [formControl]="secForm.controls['numberOfDebenture']">
                     <div *ngIf="secForm.controls['numberOfDebenture'].hasError('pattern') || secForm.controls['numberOfDebenture'].hasError('maxlength')" class="form-control-error-custom">
                      Total no. of debentures / other securities held is invalid.
                    </div> 
                     <div *ngIf="secForm.controls['numberOfDebenture'].hasError('required') && secForm.controls['numberOfDebenture'].touched" class="form-control-error-custom">
                      Total no. of debentures / other securities held is Required.
                    </div> 
                  </div>

                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Folio Number.</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="secForm.controls['folioNumber']">
                        <div *ngIf="secForm.controls['folioNumber'].hasError('pattern') || secForm.controls['folioNumber'].hasError('maxlength')" class="form-control-error-custom">
                          Folio Number is invalid.
                        </div> 
                        <div *ngIf="secForm.controls['folioNumber'].hasError('required') && secForm.controls['folioNumber'].touched" class="form-control-error-custom">
                          Folio Number Required.
                        </div>
                  </div>
                                    
                  <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="secForm.controls.selectTypes.value == 'debentures'">
                    <label>Class Of Debentures</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" 
                    [formControl]="secForm.controls['classOfDebenture']" >
                     <div *ngIf="secForm.controls['classOfDebenture'].hasError('pattern') || secForm.controls['classOfDebenture'].hasError('maxlength')" class="form-control-error-custom">
                        Class Of Debentures is invalid.
                      </div> 
                       <div *ngIf="secForm.controls['classOfDebenture'].hasError('required') && secForm.controls['classOfDebenture'].touched" class="form-control-error-custom">
                          Class Of Debentures is required.
                      </div>
                  </div>                
                </div>
                                                                  
                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="secForm.controls.selectTypes.value == 'otherssecurities'">
                    <label>Others Securities</label>
                    <input type="text" class="form-control" [formControl]="secForm.controls['otherSecurities']">
                    <div *ngIf="secForm.controls['otherSecurities'].hasError('pattern') || secForm.controls['otherSecurities'].hasError('maxlength')" class="form-control-error-custom">
                      Others Securities is invalid.
                    </div>
                  </div>
                </div>
              </form>
              <!-- <div class="form-group" align="right">
                  <button class="btn btn-sm btn-primary" (click)="savesecdata()"
                  [disabled]="!secForm.valid" > <span id="saveUpdateDirector">UPDATE</span></button>
              </div> -->
              <div class="form-group" align="right" *ngIf="!restrictmgt2TabFlag">
                  <button class="btn btn-sm btn-primary" (click)="savesecdata()" type="button" [disabled]="!(secForm.valid) || disabledOnClick">
                    <span>
                      <em class="fa fa-save"></em>&nbsp;Save </span>
                  </button>
                </div>
                <div class="form-group" align="right" *ngIf="restrictmgt2TabFlag">
                  <button class="btn btn-sm btn-primary" (click)="updateSecParticulars()" type="button" [disabled]="!(secForm.valid) || disabledOnClick">
                    <span>
                      <em class="fa fa-save"></em>&nbsp;Update </span>
                  </button>
                </div>
            <!-- </div> -->
            </div>                              
          </div>
        </div>

        <!-- personal details -->
        <div class="tab-pane" id="personalDetails" role="tabcard">
          <div class="modal-body">
            <div class="form-group" >                            
              <form [formGroup]='personaldetailsForm'>                                             
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Type of Holders</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select _ngcontent-c2="" (change)="personalDetailsTOHChange($event.target.value)" class="form-control ng-pristine ng-valid ng-touched" [formControl]="personaldetailsForm.controls['holders']"
                      style="padding:6px;">                                                                          
                      <option _ngcontent-c2="" value="" [selected]="true" >Select Type</option>
                      <option _ngcontent-c2="" value="individual">Individual</option>
                      <option _ngcontent-c2="" value="bodyCorporate">Body Corporate</option>
                      <option _ngcontent-c2="" value="others">Others</option>                                              
                      <div *ngIf="personaldetailsForm.controls['holders'].hasError('required') && personaldetailsForm.controls['holders'].touched" class="form-control-error-custom">
                        Selection is required
                      </div>
                    </select>                                            
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                    <label>Name of the debenture holder / other security holder</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['debentureName']" >
                  
                    <div class="form-control-error-custom"
                        *ngIf="personaldetailsForm.controls['debentureName'].hasError('required') && personaldetailsForm.controls['debentureName'].touched">
                        Name of the debenture holder / other security holder is required
                      </div>
                      <div
                        *ngIf="personaldetailsForm.controls['debentureName'].hasError('pattern') || personaldetailsForm.controls['debentureName'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the debenture holder / other security holder is not valid
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                      <label>Address.</label>
                      <textarea class="form-control" [formControl]="personaldetailsForm.controls['address']" maxlength="200"></textarea>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12 " *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                    <label>Unique Identification No.</label>
                    <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" [formControl]="personaldetailsForm.controls['identificationNumber']"
                    style="padding:6px;" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">                                                                         
                    <option _ngcontent-c2="" value="" [selected]="true" >Select Type</option>
                    <option _ngcontent-c2="" value="passport" [selected]="this.editMgt2Data.personal.identificationNumber=='passport'">Passport </option>
                    <option _ngcontent-c2="" value="adhar"  [selected]="this.editMgt2Data.personal.identificationNumber=='adhar'">Adhar Number</option>
                    <option _ngcontent-c2="" value="voterid" [selected]="this.editMgt2Data.personal.identificationNumber=='voterid'">Voter's Id</option>
                    <option _ngcontent-c2="" value="drivingLicense" [selected]="this.editMgt2Data.personal.identificationNumber=='drivingLicense'">Driving Licence</option>
                    <option _ngcontent-c2="" value="others" [selected]="this.editMgt2Data.personal.identificationNumber=='others'">others </option>                                                     
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumber.value == 'passport'">
                      <label>Passport Number.</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['passportNumber']" >
                      <div *ngIf="personaldetailsForm.controls['passportNumber'].hasError('pattern') || personaldetailsForm.controls['passportNumber'].hasError('maxlength')" class="form-control-error-custom">
                          Passport number is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumber.value == 'adhar'">
                      <label>Adhar Number.</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['adharNumber']" >
                      <div *ngIf="personaldetailsForm.controls['adharNumber'].hasError('pattern') || personaldetailsForm.controls['adharNumber'].hasError('maxlength')" class="form-control-error-custom">
                          Adhar number is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumber.value == 'voterid'">
                      <label>Voter's Id.</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['voterId']" >
                      <div *ngIf="personaldetailsForm.controls['voterId'].hasError('pattern') || personaldetailsForm.controls['voterId'].hasError('maxlength')" class="form-control-error-custom">
                          Voter's Id is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumber.value == 'drivingLicense'">
                      <label>Driving License.</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['drivingLicense']" >
                      <div *ngIf="personaldetailsForm.controls['drivingLicense'].hasError('pattern') || personaldetailsForm.controls['drivingLicense'].hasError('maxlength')" class="form-control-error-custom">
                          Driving License is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumber.value == 'others'">
                      <label>Any Other (Specify)</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['others']" >
                      <div *ngIf="personaldetailsForm.controls['others'].hasError('pattern') || personaldetailsForm.controls['others'].hasError('maxlength')" class="form-control-error-custom">
                          Any Other is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                      <label>PAN</label>
                      <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNumber']" >
                      <div *ngIf="personaldetailsForm.controls['panNumber'].hasError('pattern') || personaldetailsForm.controls['panNumber'].hasError('maxlength')" class="form-control-error-custom">
                          PAN is invalid.
                      </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                      <label>Nationality</label>
                      <!-- <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nationality']" >
                      <div *ngIf="personaldetailsForm.controls['nationality'].hasError('pattern') || personaldetailsForm.controls['nationality'].hasError('maxlength')" class="form-control-error-custom">
                          Nationality is invalid.
                      </div> -->
                      <select class="form-control" [formControl]="personaldetailsForm.controls['nationality']"
                        style="padding:6px;">
                        <option value="" [selected]="!personaldetailsForm.controls['nationality'].value">Select</option>
                        <option *ngFor="let country of countryList"
                          [selected]="personaldetailsForm.controls['nationality'].value==country.Country"
                          [value]="country.Country">
                          {{country.Country}}
                        </option>
                      </select>
                  </div>
                </div>
                
                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                        <label>Email-id</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailid']" >
                        <div *ngIf="personaldetailsForm.controls['emailid'].hasError('pattern')" class="form-control-error-custom">
                          Email ID is not valid.
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                        <label>Father Name</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['fatherName']" >
                        <div *ngIf="personaldetailsForm.controls['fatherName'].hasError('pattern') || personaldetailsForm.controls['fatherName'].hasError('maxlength')"  class="form-control-error-custom">
                            Father Name is not valid.
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                        <label>Mother Name</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['motherName']" >
                        <div *ngIf="personaldetailsForm.controls['motherName'].hasError('pattern') || personaldetailsForm.controls['motherName'].hasError('maxlength')"  class="form-control-error-custom">
                            Mother Name is not valid.
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Joint holders</label>
                      <div class="form-group">
                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                          <input id="copyYes" type="radio" [formControl]="personaldetailsForm.controls['jointholder']" style="position:absolute" name="jointholder"
                            value="true" class="form-check-input" (click)='showHolderYesClick()'>
                          <label for="copyYes" ng-model="yes" style="padding: 0 29px 0px 0px">YES</label>
                        </div>
                        <div class="md-radio md-radio-inline" style="display: inline-block">
                          <input id="copyNo" type="radio" [formControl]="personaldetailsForm.controls['jointholder']" style="position:absolute" name="jointholder"
                            value="false" class="form-check-input" (click)='hideHolderNoClick()'>
                          <label for="copyNo" ng-model="no">NO</label>
                        </div>
                      </div>
                    </div>  
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="showHolderYes">
                        <label>Name Of Joint Holder:</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nameOfJointHolder']">
                        <div *ngIf="personaldetailsForm.controls['nameOfJointHolder'].hasError('pattern') || personaldetailsForm.controls['nameOfJointHolder'].hasError('maxlength')" class="form-control-error-custom">
                            Name Of Joint Holder is invalid.
                        </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="showHolderYes">
                          <label>Joint holder's PAN</label>
                          <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['jointholderpanNumber']" >
                          <div *ngIf="personaldetailsForm.controls['jointholderpanNumber'].hasError('pattern') || personaldetailsForm.controls['jointholderpanNumber'].hasError('maxlength')" class="form-control-error-custom">
                              Joint holder's PAN is invalid.
                          </div>
                      </div>
                  </div>  
                  <div class="row" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                          <label>Minor</label>
                          <div class="form-group">
                            <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                              <input id="minorYes" type="radio" (change)="memberisMinorChanged()" [formControl]="personaldetailsForm.controls['isMinor']" style="position:absolute" name="isMinor"
                                value="true" class="form-check-input" (click)='showMinorYesClick()'>
                              <label for="minorYes" ng-model="yes" style="padding: 0 29px 0px 0px">YES</label>
                            </div>
                            <div class="md-radio md-radio-inline" style="display: inline-block">
                              <input id="minorNo" type="radio" (change)="memberisMinorChanged()" [formControl]="personaldetailsForm.controls['isMinor']" style="position:absolute" name="isMinor"
                                value="false" class="form-check-input" (click)='hideMinorNoClick()'>
                              <label for="minorNo" ng-model="no">NO</label>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="minorYes">
                            <label>Date of Birth:</label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input class="form-control" [maxDate]="TodayDate" [formControl]="personaldetailsForm.controls['dateOfBirth']" [(ngModel)]="dateOfBirthModel"
                                  style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                  name="birthdate" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                              <button class="input-group-addon" (click)="a.toggle()"
                                  type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          <!-- <label>Date of Birth:</label><br><br>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['dateOfBirth']"> -->
                        </div>
                        <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="minorYes">
                            <label>Name and Address of Guardian</label>
                            <!-- <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['guardian']"> -->
                            <textarea class="form-control" [formControl]="personaldetailsForm.controls['guardian']" maxlength="1000"></textarea>
                            <div *ngIf="personaldetailsForm.controls['guardian'].hasError('maxlength')" class="form-control-error-custom">
                                Max Length is 1000 characters.
                            </div>
                        </div>
                        <div class="form-group col-md-4 col-sm-6 col-xs-12 " *ngIf="minorNo">
                          <label>Marital Status</label>
                          <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" (change)="maritialStatusChanged($event)"
                          [formControl]="personaldetailsForm.controls['maritialstatus']"  placeholder="Select type of Marital Status"
                          style="padding:6px;" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">                                                                              
                          <option _ngcontent-c2="" value=" " selected>
                            Select  Type
                          </option>
                          <option _ngcontent-c2="" value="single">
                            Single
                          </option>
                          <option _ngcontent-c2="" value="married">
                            Married
                          </option>
                          </select>
                      </div>
                      <div *ngIf="showTermLoadFields && minorNo" class="form-group col-md-4 col-sm-6 col-xs-12" >
                          <label>Name of the Spouse</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['spouseName']" >
                          <div *ngIf="personaldetailsForm.controls['spouseName'].hasError('pattern') || personaldetailsForm.controls['spouseName'].hasError('maxlength')" class="form-control-error-custom">
                              Name of the Spouse is invalid.
                          </div>
                      </div>
                    </div>  

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'individual'">
                          <label>Occupation</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['occupation']" >
                          <div *ngIf="personaldetailsForm.controls['occupation'].hasError('pattern') || personaldetailsForm.controls['occupation'].hasError('maxlength')" class="form-control-error-custom">
                              Occupation is invalid.
                          </div>
                      </div>
                    </div>
                <!-- </div> -->

                <!-- Body Corporate option -->
                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>Name of the debenture holder / other security holder</label>
                        <span _ngcontent-c2="" style="color: red;">*</span>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['debentureNameBodyCorporate']" >
                     
                        <div class="form-control-error-custom"
                        *ngIf="personaldetailsForm.controls['debentureNameBodyCorporate'].hasError('required') && personaldetailsForm.controls['debentureNameBodyCorporate'].touched">
                        Name of the debenture holder / other security holder is required
                      </div>
                      <div
                        *ngIf="personaldetailsForm.controls['debentureNameBodyCorporate'].hasError('pattern') || personaldetailsForm.controls['debentureNameBodyCorporate'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the debenture holder / other security holder is not valid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>Registered address</label><br><br>
                        <textarea class="form-control" [formControl]="personaldetailsForm.controls['registeredAddressBodyCorporate']" ></textarea>
                        <div *ngIf="personaldetailsForm.controls['registeredAddressBodyCorporate'].hasError('pattern') || personaldetailsForm.controls['registeredAddressBodyCorporate'].hasError('maxlength')" class="form-control-error-custom">
                            Registered address is invalid
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>PAN</label><br><br>
                        <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNumberBodyCorporate']" >
                        <div *ngIf="personaldetailsForm.controls['panNumberBodyCorporate'].hasError('pattern') || personaldetailsForm.controls['panNumberBodyCorporate'].hasError('maxlength')" class="form-control-error-custom">
                            PAN is invalid.
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>CIN/ Registration No.</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['registrationNumberBodyCorporate']" >
                        <div *ngIf="personaldetailsForm.controls['registrationNumberBodyCorporate'].hasError('pattern') || personaldetailsForm.controls['registrationNumberBodyCorporate'].hasError('maxlength')" class="form-control-error-custom">
                            CIN/ Registration No. is invalid.
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>E-mail Id</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailIdBodyCorporate']" >
                        <div *ngIf="personaldetailsForm.controls['emailIdBodyCorporate'].hasError('pattern')" class="form-control-error-custom">
                          Email ID is not valid.
                        </div>
                    </div>
                </div>

                <section class="panel panel-default" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                    <div class="panel-heading">
                        <h5 class="panel-title">Authorised Signatory</h5>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                          <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                              <label>Name of Authorised Signatory</label>
                              <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['authorisedSignatoryBodyCorporate']" >
                              <div *ngIf="personaldetailsForm.controls['authorisedSignatoryBodyCorporate'].hasError('maxlength')" class="form-control-error-custom">
                                  Name of Authorised Signatory is not valid.
                              </div>
                          </div>
                          <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                              <label>Designation</label>
                              <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['designationBodyCorporate']" >
                              <div *ngIf="personaldetailsForm.controls['designationBodyCorporate'].hasError('maxlength')" class="form-control-error-custom">
                                  Designation is not valid.
                              </div>
                          </div>
                          <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                              <label>Date of Board Resolution</label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input class="form-control" [maxDate]="TodayDate" [formControl]="personaldetailsForm.controls['dateOfBoardBodyCorporate']" [(ngModel)]="dateOfBoardModel"
                                  style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                   ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();">
                              <button class="input-group-addon" (click)="a.toggle();"
                                  type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                              <!-- <label>Date of Board Resolution</label>
                              <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['dateOfBoardBodyCorporate']" > -->
                          </div>
                      </div>
                      <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                          <label>Upload Document</label>
                          <input type="file" class="form-control" [formControl]="personaldetailsForm.controls['uploadBodyCorporate']" >
                      </div> -->

                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="!fileAvailable && personaldetailsForm.controls.holders.value == 'bodyCorporate'">
                        <label>Upload Document</label>
                        <input type="file" class="form-control" (change)="fileChangeEvent($event)">
                        <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                      </div>

                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="fileAvailable">
                        <label>Upload Document</label>
                        <div>
                          <input type="text" data-toggle="tooltip" [title]="resolutionFileName"
                            [formControl]="personaldetailsForm.controls.uploadBodyCorporate"
                            [(ngModel)]="resolutionFileName" readonly='true' class='form-control col-md-6'
                            style="display: inline-block;" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4">
                            
                          <button type="button" class="btn-sm btn btn-primary form-control col-md-2"
                            (click)='downloadCtcDoc(documentManagementID);'>
                            <i class="fa fa-download"></i>
                          </button>
                          <button type="button" class="btn-sm btn btn-primary  form-control col-md-3"
                            (click)='addFilesOnUpdate();'>Add New</button>
                        </div>
                       
                      </div>

                    </div>
                </section>

                <!-- Other Option -->
                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                        <label>Name of the debenture holder / other security holder</label>
                        <span _ngcontent-c2="" style="color: red;">*</span>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['debentureNameOthers']" >
                     
                        <div class="form-control-error-custom"
                        *ngIf="personaldetailsForm.controls['debentureNameOthers'].hasError('required') && personaldetailsForm.controls['debentureNameOthers'].touched">
                        Name of the debenture holder / other security holder is required
                      </div>
                      <div
                        *ngIf="personaldetailsForm.controls['debentureNameOthers'].hasError('pattern') || personaldetailsForm.controls['debentureNameOthers'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the debenture holder / other security holder is not valid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                        <label>Name of joint holders, if any</label>
                        <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['jointHolderOthers']" >
                        <div *ngIf="personaldetailsForm.controls['jointHolderOthers'].hasError('pattern') || personaldetailsForm.controls['jointHolderOthers'].hasError('maxlength')" class="form-control-error-custom">
                            Name of joint holders is not valid.
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                        <label>Address</label>
                        <!-- <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['addressOthers']" > -->
                        <textarea class="form-control" [formControl]="personaldetailsForm.controls['addressOthers']" maxlength="200"></textarea>
                        <div *ngIf="personaldetailsForm.controls['addressOthers'].hasError('pattern') || personaldetailsForm.controls['addressOthers'].hasError('maxlength')" class="form-control-error-custom">
                            Address is not valid.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                        <label>PAN</label>
                        <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNumberOthers']" >
                        <div *ngIf="personaldetailsForm.controls['panNumberOthers'].hasError('pattern') || personaldetailsForm.controls['panNumberOthers'].hasError('maxlength')" class="form-control-error-custom">
                            PAN is invalid.
                        </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12 " *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                        <label>Unique Identification No.</label>
                        <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" 
                        [formControl]="personaldetailsForm.controls['identificationNumberOthers']"
                        style="padding:6px;" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                                                                                                          
                        <option _ngcontent-c2="" value="" [selected]="true" >
                          Select  Type
                        </option>
                        <option _ngcontent-c2="" [selected]="this.editMgt2Data.personal.identificationNumberOthers=='passport'" value="passport">
                          Passport 
                        </option>
                        <option _ngcontent-c2="" [selected]="this.editMgt2Data.personal.identificationNumberOthers=='adhar'" value="adhar">
                          Adhar Number
                        </option>
                        <option _ngcontent-c2="" [selected]="this.editMgt2Data.personal.identificationNumberOthers=='voterid'" value="voterid">
                          Voter's Id
                        </option>
                        <option _ngcontent-c2="" [selected]="this.editMgt2Data.personal.identificationNumberOthers=='drivingLicense'" value="drivingLicense">
                            Driving Licence
                        </option>
                        <option _ngcontent-c2="" [selected]="this.editMgt2Data.personal.identificationNumberOthers=='others'" value="others">
                              others
                        </option>
                                                                                  
                        <!-- <div *ngIf="personaldetailsForm.controls['holders'].hasError('required') && personaldetailsForm.controls['holders'].touched" class="form-control-error-custom">
                          Selection is required</div> -->
                      </select>
                    </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumberOthers.value == 'passport'">
                          <label>Passport Number.</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['passportNumberOthers']" >
                          <div *ngIf="personaldetailsForm.controls['passportNumberOthers'].hasError('pattern') || personaldetailsForm.controls['passportNumberOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Passport number is invalid.
                          </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumberOthers.value == 'adhar'">
                          <label>Adhar Number.</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['adharNumberOthers']" >
                          <div *ngIf="personaldetailsForm.controls['adharNumberOthers'].hasError('pattern') || personaldetailsForm.controls['adharNumberOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Adhar Number is invalid.
                          </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumberOthers.value == 'voterid'">
                          <label>Voter's Id.</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['voterIdOthers']" >
                          <div *ngIf="personaldetailsForm.controls['voterIdOthers'].hasError('pattern') || personaldetailsForm.controls['voterIdOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Voter's Id is invalid.
                          </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumberOthers.value == 'drivingLicense'">
                          <label>Driving License.</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['drivingLicenseOthers']" >
                          <div *ngIf="personaldetailsForm.controls['drivingLicenseOthers'].hasError('pattern') || personaldetailsForm.controls['drivingLicenseOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Driving License is invalid.
                          </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.identificationNumberOthers.value == 'others'">
                          <label>Others</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['othersOthers']" >
                          <div *ngIf="personaldetailsForm.controls['othersOthers'].hasError('pattern') || personaldetailsForm.controls['othersOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Others is invalid.
                          </div>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                          <label>Nationality</label>
                          <!-- <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nationalityOthers']" >
                          <div *ngIf="personaldetailsForm.controls['nationalityOthers'].hasError('pattern') || personaldetailsForm.controls['nationalityOthers'].hasError('maxlength')" class="form-control-error-custom">
                              Nationality is invalid.
                          </div> -->
                          <select class="form-control" [formControl]="personaldetailsForm.controls['nationalityOthers']"
                            style="padding:6px;">
                            <option value="" [selected]="!personaldetailsForm.controls['nationalityOthers'].value">Select</option>
                            <option *ngFor="let country of countryList"
                              [selected]="personaldetailsForm.controls['nationalityOthers'].value==country.Country"
                              [value]="country.Country">
                              {{country.Country}}
                            </option>
                          </select>
                      </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.holders.value == 'others'">
                      <label>Email-Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailOthers']" >
                      <div *ngIf="personaldetailsForm.controls['emailOthers'].hasError('pattern')" class="form-control-error-custom">
                            Email ID is not valid.
                      </div>
                  </div>
                </div>

              </form>
                                                              
              <!-- <div class="form-group" align="right">
                <button class="btn btn-sm btn-primary" (click)="savepersonaldata()" type="Submit"
                [disabled]="!personaldetailsForm.valid" > <span id="saveUpdateDirector">UPDATE</span></button>
              </div> -->
              <div class="form-group" align="right" *ngIf="addPersonalBtn">
                  <button class="btn btn-sm btn-primary" (click)="savepersonaldata()" type="button" [disabled]="!personaldetailsForm.valid || disabledOnClick || !fileExtension">
                    <span id="saveUpdateDirector">
                      <i class="fa fa-save"></i>&nbsp;
                      Save
                    </span>
                  </button>
                </div>
                <div class="form-group" align="right" *ngIf="!addPersonalBtn">
                  <button class="btn btn-sm btn-primary" (click)="savepersonaldata()" type="button" [disabled]="!personaldetailsForm.valid || disabledOnClick || !fileExtension">
                    <span id="saveUpdateDirector">
                      <i class="fa fa-save"></i>&nbsp;
                      Update
                    </span>
                  </button>
                </div>
                                                  
            </div>
          </div>
        </div> 

        <!-- details of holding -->
        <div class="tab-pane" id="detailsOfHolding" role="tabcard">
            <div class="modal-body">
              <div class="form-group" >                                 
                <form [formGroup]='holdingForm'>                                               
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                      <label>Type of Holders</label>
                      <span _ngcontent-c2="" style="color: red;">*</span>
                      <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched" 
                      [formControl]="holdingForm.controls['typesOfHolders']"
                      style="padding:6px;" (change)="detailsOfHoldingTOHChange($event.target.value)">                                                                              
                      <option _ngcontent-c2="" value="" [selected]="true" > Select Type</option>
                      <option _ngcontent-c2="" value="individual">Individual </option>
                      <option _ngcontent-c2="" value="bodyCorporate">Body Corporate</option>
                      <option _ngcontent-c2="" value="others">Others</option>                                                    
                      <!-- <div *ngIf="personaldetailsForm.controls['holders'].hasError('required') && personaldetailsForm.controls['holders'].touched" class="form-control-error-custom">
                        Selection is required</div> -->
                      </select>                                         
                    </div>
                    <div class="form-group  col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                        <label>Date of becoming debenture holder/ other security holder:</label>
                        <div class="input-group">
                           <input class="form-control" [maxDate]="TodayDate" [formControl]="holdingForm.controls['dateOfDebenture']" [(ngModel)]="DateOfDebentureModel"
                           style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                           name="dateOfDebenture" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();b.close();c.close();d.close();">
                           <button class="input-group-addon" (click)="a.toggle();b.close();c.close();d.close();"
                           type="button">
                           <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                           </button>
                         </div>
                    </div>
                    <div class="form-group  col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                       <br> <label>Date of receipt of nomination:</label>
                        <div class="input-group" >
                           <input class="form-control" [maxDate]="TodayDate" [formControl]="holdingForm.controls['dateOfreceipt']" [(ngModel)]="DateOfreceiptModel"
                           style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                           name="dateOfreceipt" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();a.close();c.close();d.close();">
                           <button class="input-group-addon" (click)="b.toggle();a.close();c.close();d.close();"
                           type="button">
                           <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                           </button>
                         </div>
                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                      <label>Name of nominee</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls['nomineeName']" >
                  </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Address of nominee</label>
                          <textarea class="form-control" [formControl]="holdingForm.controls['nomineeAddress']" ></textarea>
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>No. of debentures /securities kept in abeyance, if any:</label>
                          <input type="text" class="form-control" [formControl]="holdingForm.controls['noOfDebenture']" >
                      </div>
                     
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                      <label>Record of lien on debentures/securities,if any:</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls['record']" >
                  </div>
                      <div class="form-group  col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Date of cessation as debenture holder/ other security holder:</label><br>
                          <div class="input-group" >
                             <input class="form-control" [maxDate]="TodayDate" [formControl]="holdingForm.controls['dateOfCessation']" [(ngModel)]="dateOfCessationModel"
                             style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                             name="dateOfCessation" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle();a.close();b.close();d.close();">
                             <button class="input-group-addon" (click)="c.toggle();a.close();b.close();d.close();"
                             type="button">
                             <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                             </button>
                           </div>
                      </div>
                    
                  </div>
                      <div class="form-group col-md-12 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Whether repayment of the debentures / other securities is secured:</label><br><br>
                          <div class="form-group">
                            <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                              <input id="repaymentYes" type="radio" [formControl]="holdingForm.controls['isRepayment']" style="position:absolute" name="isRepayment"
                                value="true" class="form-check-input" (click)='showRepaymentYesClick()'>
                              <label for="repaymentYes" ng-model="yes" style="padding: 0 29px 0px 0px">YES</label>
                            </div>
                            <div class="md-radio md-radio-inline" style="display: inline-block" >
                              <input id="repaymentNo" type="radio" [formControl]="holdingForm.controls['isRepayment']" style="position:absolute" name="isRepayment"
                                value="false" class="form-check-input" (click)='hideRepaymentNoClick()'>
                              <label for="repaymentNo" ng-model="no">NO</label>
                            </div>
                          </div>
                          <div class="row">
                              <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="RepaymentYes">
                                  <label>Charge Identification Number allotted for the charge:</label><br><br>
                                  <input type="text" class="form-control" [formControl]="holdingForm.controls['chargeIdentificationNumber']">
                              </div>
                              <div class="form-group  col-md-4 col-sm-6 col-xs-12" *ngIf="RepaymentYes">
                                  <label>If secured, date of registration of charge with the ROC:</label><br><br>
                                  <div class="input-group" >
                                     <input class="form-control" [maxDate]="TodayDate" [formControl]="holdingForm.controls['dateOfRegister']" [(ngModel)]="dateOfRegisterModel"
                                     style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                     name="dateOfRegister" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle();a.close();b.close();c.close();">
                                     <button class="input-group-addon" (click)="d.toggle();a.close();b.close();c.close();"
                                     type="button">
                                     <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                     </button>
                                   </div>
                              </div>
                              <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="RepaymentYes">
                                  <label>Brief particulars of the assets to secure such debentures / other securities:</label>
                                  <input type="text" class="form-control" [formControl]="holdingForm.controls['breifParticulars']">
                              </div>
                          </div>
                      </div>
                  <!-- </div> -->
                  <div class="row">
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Particulars of interest mandates, power of attorney and other instructions, if any:</label>
                          <input type="text" class="form-control" [formControl]="holdingForm.controls['interestMandates']" >
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Instruction for sending notices etc., if any </label> <br><br>
                          <input type="text" class="form-control" [formControl]="holdingForm.controls['instruction']" >
                      </div>
                      <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'individual'">
                          <label>Ref in CHG 7</label> <br><br>
                          <input type="text" class="form-control" [formControl]="holdingForm.controls['ref1']" >
                      </div>
                  </div>
                
                  <!-- Individual Details Of Holding End -->

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                      <label>Date of becoming debenture holder/ other security holder:</label>
                      <div class="input-group" >
                          <input class="form-control" [formControl]="holdingForm.controls.dobDebentureHolderOtherSecurityHolder" [(ngModel)]="dateOfDebentureHolderModel"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                              ngbDatepicker #az="ngbDatepicker" (click)="az.toggle();bz.close();cz.close();">
                          <button class="input-group-addon" (click)="az.toggle();bz.close();cz.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                          </button> 
                      </div>
                    </div>
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                         <label>Record of lien on debentures/securities,if any:</label>
                         <textarea class="form-control" [formControl]="holdingForm.controls.recordLienOnDebenturesSecuritiesIfAny" maxlength="200"> </textarea>
                    </div>
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                       <label>Date of cessation as debenture holder/ other security holder:</label>
                       <div class="input-group" >
                           <input class="form-control" [formControl]="holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder" [(ngModel)]="dateOfCessationDebentureHolderModel"
                               style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                               ngbDatepicker #bz="ngbDatepicker" (click)="bz.toggle();az.close();cz.close();">
                           <button class="input-group-addon" (click)="bz.toggle();az.close();cz.close();" type="button">
                               <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                           </button> 
                       </div>
                    </div>
                 
                  </div>

                  <div class="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                          <label>Whether repayment of the debentures / other securities is secured:</label>
                          <select class="form-control" [formControl]="holdingForm.controls['whetherRepaymentoftheDebenturesOtherSecuritiesisSecured']" style="padding:6px;">
                            <option value="" [selected]="true">Select</option>
                            <option value="yes" [selected]="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value =='yes'">Yes</option>
                            <option value="no" [selected]="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value =='no'">No</option>
                        </select>
                    </div>
                 
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value =='yes' && holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                       <label  class="form-group">If secured, date of registration of charge with the ROC:</label>
                       <div class="input-group">
                           <input class="form-control" [formControl]="holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC" [(ngModel)]="dateOfRegistrationModel"
                               style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                               ngbDatepicker #cz="ngbDatepicker" (click)="cz.toggle();az.close();bz.close();">
                           <button class="input-group-addon" (click)="cz.toggle();az.close();bz.close();" type="button">
                               <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                           </button>
                       </div>
                    </div>       
                               
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value =='yes' && holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                       <label>Charge Identification Number allotted for the charge:</label>
                       <input type="text" class="form-control" [formControl]="holdingForm.controls.chargeIdentificationNumberAllocatedForCharge" > 
                       <!-- <div *ngIf="holdingForm.controls['chargeIdentificationNumberAllocatedForCharge'].hasError('pattern')" class="form-control-error-custom">
                        The entry should contain only numeric entries
                       </div> -->
                    </div>
              
                  </div>

                  <div class ="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value=='yes' && holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                      <label>Brief particulars of the assets to secure such debentures / other securities:</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities" > 
                    </div>
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                      <label>Particulars of interest mandates,power of attorney and other instructions, if any:</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny" > 
                    </div>
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                      <label>Instruction for sending notices etc., if any</label> <br><br>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.instructionForSendingNoticesEtcIfAny" > 
                    </div>
              
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'bodyCorporate'">
                      <label>Ref in CHG 7</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.refInCHG7" > 
                    </div>
                  </div>
                  <!-- Body Corporate Details Of Holding End  -->

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label>Date of becoming debenture holder/other security holder:</label>
                      <div class="input-group" >
                          <input class="form-control" [formControl]="holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers" [(ngModel)]="dateOfCessationDebentureHolderModel"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                              ngbDatepicker #az="ngbDatepicker" (click)="az.toggle();bz.close();cz.close();dz.close();">
                          <button class="input-group-addon" (click)="az.toggle();bz.close();cz.close();dz.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                          </button> 
                      </div>
                    </div>
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label>Date of receipt of nomination:</label>
                      <div class="input-group" >
                          <input class="form-control" [formControl]="holdingForm.controls.doReceiptOfNomination" [(ngModel)]="dateOfReceiptModel"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                              ngbDatepicker #bz="ngbDatepicker" (click)="bz.toggle();az.close();cz.close();dz.close();">
                          <button class="input-group-addon" (click)="bz.toggle();az.close();cz.close();dz.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                          </button> 
                      </div>
                    </div> 
              
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label>Name of nominee</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.nameOfNominee" > 
                      <!-- <div *ngIf="holdingForm.controls['nameOfNominee'].hasError('pattern')" class="form-control-error-custom">
                        The entry should contain only text entries
                      </div> -->
                    </div>       
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                        <label>Address of nominee</label>
                        <textarea class="form-control" [formControl]="holdingForm.controls.addressOfNominee" maxlength="200"> </textarea>
                    </div>
            
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label>No. of debentures /securities kept in abeyance, if any:</label>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.noOfDebenturesSecuritiesKeptInAbeyanceIfAny" > 
                      <!-- <div *ngIf="holdingForm.controls['noOfDebenturesSecuritiesKeptInAbeyanceIfAny'].hasError('pattern')" class="form-control-error-custom">
                        The entry should contain only numeric entries
                      </div> -->
                    </div>
            
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                        <label>Record of lien on debentures/securities,if any:</label>
                        <input type="text" class="form-control" [formControl]="holdingForm.controls.recordOfLienOnDebenturesSecuritiesIfAny" > 
                    </div>
            
                </div>

                <div clas="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label  class="form-group">Date of cessation as debenture holder/ other security holder:</label>
                      <div class="input-group">
                          <input class="form-control" [formControl]="holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers" [(ngModel)]="dateOfCessationDebentureHolderOtherModel"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                              ngbDatepicker #cz="ngbDatepicker" (click)="cz.toggle();az.close();bz.close();dz.close();">
                          <button class="input-group-addon" (click)="cz.toggle();az.close();bz.close();dz.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                          </button>
                      </div>
                  </div> 
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                        <label>Whether repayment of the debentures / other securities is secured:</label>
                        <select class="form-control" [formControl]="holdingForm.controls['whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers']" style="padding:6px;">
                          <option value="" [selected]="true">Select</option>
                          <option [selected]="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value =='yes'" value="yes">Yes</option>
                          <option [selected]="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value =='no'" value="no">No</option>
                      </select>
                  </div>
                </div>

                <div class ="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value=='yes'">
                        <label  class="form-group">If secured, date of registration of charge with the ROC:</label>
                        <div class="input-group">
                            <input class="form-control" [formControl]="holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers" [(ngModel)]="dateOfRegistrationROCOthersModel"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                ngbDatepicker #dz="ngbDatepicker" (click)="dz.toggle();az.close();bz.close();cz.close();">
                            <button class="input-group-addon" (click)="dz.toggle();az.close();bz.close();cz.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                            </button>
                        </div>
                    </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value =='yes'">
                      <label>Charge Identification Number allotted for the charge:</label><br>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.chargeIdentificationNumberAllocatedForChargeOthers" >
                      <!-- <div *ngIf="holdingForm.controls['chargeIdentificationNumberAllocatedForChargeOthers'].hasError('pattern')" class="form-control-error-custom">
                        The entry should contain only numeric entries
                      </div>  -->
                  </div>
                  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value =='yes'">
                      <label>Brief particulars of the assets to secure such debentures / other securities:</label><br>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities" > 
                  </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                        <label>Particulars of interest mandates,power of attorney and other instructions, if any:</label>
                        <input type="text" class="form-control" [formControl]="holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers" > 
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                        <label>Instruction for sending notices etc., if any</label><br><br>
                        <input type="text" class="form-control" [formControl]="holdingForm.controls.instructionForSendingNoticesEtcIfAnyOthers" > 
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="holdingForm.controls.typesOfHolders.value == 'others'">
                      <label>Ref in CHG 7</label><br><br>
                      <input type="text" class="form-control" [formControl]="holdingForm.controls.refInCHG7Others" > 
                    </div>
                </div>
                <!-- <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Nationality</label>
                    <div class="form-group">
                        <select class="form-control" [formControl]="directorMasterForm.controls['Nationality']" style="padding:6px;">
                            <option value="null" [selected]="true">Select Nationality</option> 
                            <option value="null" [selected]="true">Select</option>
                            <option *ngFor="let country of countryList" [value]="country.Country">
                                {{country.Country}}
                            </option>
                        </select>
                    </div>
                </div> -->
                </form>
                <!-- <div class="form-group" align="right">
                    <button class="btn btn-sm btn-primary" (click)="saveholdingdata()" type="Submit"
                    [disabled]="!holdingForm.valid" > <span id="saveUpdateDirector">UPDATE</span></button>
                  </div> -->
                  <div class="form-group" align="right" *ngIf="addHoldingBtn">
                      <button class="btn btn-sm btn-primary" (click)="saveholdingdata()" type="button" [disabled]="!holdingForm.valid || disabledOnClick">
                        <span id="saveUpdateDirector">
                          <i class="fa fa-save"></i>&nbsp;
                          Save
                        </span>
                      </button>
                  </div>
                  <div class="form-group" align="right" *ngIf="!addHoldingBtn">
                      <button class="btn btn-sm btn-primary" (click)="saveholdingdata()" type="button" [disabled]="!holdingForm.valid || disabledOnClick">
                        <span id="saveUpdateDirector">
                          <i class="fa fa-save"></i>&nbsp;
                          Update
                        </span>
                      </button>
                  </div>
              </div>
            </div>
        </div>    

        <div class="tab-pane" id="detailsOfSecurity" role="tabcard">
            <div class="form-group clearfix" style="margin-bottom: 1px;">
                <div class="col-sm-12">
                  <button class="btn btn-success pull-right" (click)="addNewFieldsModal()"
                    class="btn btn-sm btn-primary mb-2" type="button" style="margin-top: 10px; float:right" 
                    [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}">
                    <i class="fa fa-plus"></i>&nbsp;Add</button>
                </div>
              </div>
        

               <!-- Date Filter  -->
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
           
          

            <div class="col-md-3">
              <br>
              <!-- <label>Date of transfer/ transmission/ forfeiture / redemption etc of membership </label> -->
              <div class="input-group" (click)="$event.stopPropagation()">
                From :&nbsp;
                <input id="dateFrom" class="form-control" [minDate]="futureFromDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateFrom" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateFrom">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              
              </div>
            </div>


            <div class="col-md-3">
              <br>
              <!-- <label> Date of allotment/ transfer </label><br> -->
              <div class="input-group" (click)="$event.stopPropagation()">
              
                 To :&nbsp;
                <input id="dateTo" class="form-control" [minDate]="futureToDate"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateTo" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateTo">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div>






            <div class="col-md-4 col-sm-6 col-xs-12">
              <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
              <br>
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->
          <!-- Details of Holding List Table -->

          <div class="card-block datatable-card-block">
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptionsOfHolding" [dtTrigger]="dtTriggerHolding"
                      class="table table-hover compact cell-border nowrap stripe" id="detailsOfHoldinglistTable" style="cursor: pointer;">
                      <thead>
                        <tr>
                          <th>Type of Holding</th>
                          <th>Allotment No./<br> Transfer No</th>
                          <th>Certificate No</th>
                          <th>Date of transfer/<br> transmission/ forfeiture /<br> redemption etc of membership</th>
                          <th>Date of allotment/<br> transfer</th>
                          <th>Action</th>
                       
                        </tr>

                      </thead>
                      <tbody>
                        <tr *ngFor="let list of holdingList;">
                          <td>{{list.securitiesDetails.typeOfHolding}}</td>
                          <td>{{list.securitiesDetails.allotmentNumber}}</td>
                          <td>{{list.securitiesDetails.certificateNo}}</td>

                          <td>
                            {{list.securitiesDetails.dateOfTransfer  | date: 'dd-MM-yyyy'}}
                          </td>
                       
                          <td>
                            {{list.securitiesDetails.datebuyback  | date: 'dd-MM-yyyy'}}
                          </td>
                         


                          <td style='white-space: nowrap'>
                            <a>
                              <button type="button" class="btn-sm btn btn-warning" (click)="editSecurityDetails(list.securitiesDetails._id)"
                              [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}"> 
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(list.securitiesDetails._id)"
                              [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}">
                                  <span class="icmn-bin"></span>
                                </button>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
          style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete shareholding details?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteholdingdetail()">
                  <i class="fa fa-check"></i>&nbsp;Yes
                </button>
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                  <i class="fa fa-times"></i>&nbsp;Close
                </button>
              </div>
            </div>
          </div>
       </div>

      <div class="modal fade" id="addNewForm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
        style="top: 50px;">
        <div class="modal-dialog dynamicFieldModal" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabelForDelete">
                <i class="fa fa-question-circle-o mr-2"></i>Add Details Securities</h5>
              <button aria-label="Close" class="close" data-dismiss="modal" (click)="resetFields()" type="button">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <button *ngIf="addButton" class="btn btn-success pull-right" (click)="addNewFields()" [appHasPermission]="{'Url': '/register/mgt2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt2List'}"
                    class="btn btn-sm btn-primary mb-2" type="button" style="margin-top: 10px;float:right">
                    <i class="fa fa-plus"></i>&nbsp;Add</button>
                  <form  class="form-horizontal" [formGroup]="addSecurityForm">
                    <div class="col-md-12 clearfix" formArrayName="newField" *ngFor="let Field of newFieldArray; let i = index;" style="overflow-x: auto; border: 1px solid #b2d0ce; margin-bottom: 20px; padding: 15px;">
                      <div [formGroupName]="i">
                        <div class="row">
                          <div class="col-md-12">
                            <table style="margin-bottom: 10px; width: auto; min-width: 100%;">
                              <tbody>
                                <!-- ALL Labels in ONE Row -->
                                <tr>
                                  <td style="padding: 5px; min-width: 150px;"><label>Type of Holding<span style="color: red;">*</span></label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Allotment No./ Transfer No.</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Date of allotment/ transfer</label></td>
                                  <td style="padding: 5px; min-width: 200px;"><label>No. of debentures / other securities allotted/ transferred</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Distinctive numbers (From)</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Distinctive numbers (To)</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Folio of transferor</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Name of transferor</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Date of issue / endorsement</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Certificate No.<span style="color: red;">*</span></label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Payable</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Paid</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Due</label></td>
                                  <td style="padding: 5px; min-width: 250px;"><label>If debentures issued for consideration other than cash</label></td>
                                  <td style="padding: 5px; min-width: 180px;"><label>Date of transfer/transmission/forfeiture/redemption</label></td>
                                  <td style="padding: 5px; min-width: 180px;"><label>No. of units transferred/transmitted/forfeited/redeemed</label></td>
                                  <td style="padding: 5px; min-width: 200px;"><label>Distinctive numbers (transfer/transmission) From</label></td>
                                  <td style="padding: 5px; min-width: 200px;"><label>Distinctive numbers (transfer/transmission) To</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Folio of transferee</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Name of transferee</label></td>
                                  <td style="padding: 5px; min-width: 180px;"><label>Balance units left</label></td>
                                  <td style="padding: 5px; min-width: 150px;"><label>Other remarks</label></td>
                                  <td style="padding: 5px; min-width: 80px;"><label>Action</label></td>
                                </tr>
                                
                                <!-- ALL Inputs in ONE Row -->
                                <tr>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <select class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.typeOfHolding" style="padding:6px;">
                                      <option value="Allotment">Allotment</option>
                                      <option value="Transfer">Transfer</option>
                                      <option value="Transmission">Transmission</option>
                                      <option value="Redemption">Redemption</option>
                                    </select>
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls['typeOfHolding'].hasError('required') && addSecurityForm.controls.newField.controls[i].controls['typeOfHolding'].touched" class="form-control-error-custom">Required</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.allotmentNumber">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.allotmentNumber.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.allotmentNumber.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <div class="input-group">
                                      <input class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.datebuyback" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #dbb="ngbDatepicker">
                                      <button class="input-group-addon" type="button" (click)="dbb.toggle()"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                    </div>
                                  </td>
                                  <td style="padding: 5px; min-width: 200px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.numberOfDebentures">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.numberOfDebentures.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.numberOfDebentures.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberFrom">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberFrom.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberFrom.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberTo">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberTo.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.distinctiveNumberTo.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.folioTransferor">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.folioTransferor.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.folioTransferor.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.nameOfTransferor">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.nameOfTransferor.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.nameOfTransferor.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <div class="input-group">
                                      <input class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.dateOfIssue" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #doi="ngbDatepicker">
                                      <button class="input-group-addon" type="button" (click)="doi.toggle()"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                    </div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.certificateNo">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.certificateNo.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.certificateNo.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.amountPayable">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.amountPayable.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.amountPayable.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.amountPaid">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.amountPaid.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.amountPaid.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.amountDue">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.amountDue.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.amountDue.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 250px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.debenturesOtherSecurities">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.debenturesOtherSecurities.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.debenturesOtherSecurities.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 180px;">
                                    <div class="input-group">
                                      <input class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.dateOfTransfer" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #dot="ngbDatepicker">
                                      <button class="input-group-addon" type="button" (click)="dot.toggle()"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                    </div>
                                  </td>
                                  <td style="padding: 5px; min-width: 180px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.noOfUnitsTransferred">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.noOfUnitsTransferred.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.noOfUnitsTransferred.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 200px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersFrom">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersFrom.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersFrom.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 200px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersTo">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersTo.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.distinctiveNumbersTo.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.folioOfTransferee">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.folioOfTransferee.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.folioOfTransferee.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.nameOfTransferee">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.nameOfTransferee.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.nameOfTransferee.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 180px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.balanceUnitsLeft">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.balanceUnitsLeft.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.balanceUnitsLeft.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style="padding: 5px; min-width: 150px;">
                                    <input type="text" class="form-control" [formControl]="addSecurityForm.controls.newField.controls[i].controls.otherRemarks">
                                    <div *ngIf="addSecurityForm.controls.newField.controls[i].controls.otherRemarks.hasError('pattern')|| addSecurityForm.controls.newField.controls[i].controls.otherRemarks.hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                  </td>
                                  <td style='padding: 5px; min-width: 80px; text-align:center; vertical-align:middle;'>
                                    <button type="button" class="btn-sm btn btn-danger" (click)="removeField(i)" *ngIf="addButton"><span class="icmn-bin"></span></button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button *ngIf="addButton" type="button" class="btn btn-sm btn-primary" (click)="saveSecurityDetails()" [disabled]= "!(addSecurityForm.valid) || disabledOnClick">
                <i class="fa fa-check"></i>&nbsp;Save
              </button>
              <button *ngIf="!addButton" type="button" class="btn btn-sm btn-primary" (click)="updateSecurityDetails()" [disabled]= "!(addSecurityForm.valid) || disabledOnClick">
                <i class="fa fa-check"></i>&nbsp;Update
              </button>
              <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal" (click)="resetFields()">
                <i class="fa fa-times"></i>&nbsp;Close
              </button>
            </div>
          </div>
        </div>
      </div>
      
    </div>  
      <!-- details of security -->
        <!-- <div class="tab-pane" id="detailsOfSecurity" role="tabcard">
            <form [formGroup]="addForm">
              <div class="container">
                <div class="col-md-12">
                  <div class="form-group">
                    <section class='card'>
                      <div class="col-md-12">
                        <div class="margin-bottom-50">
                          <div class="table-responsive">
                            <div class="table table-hover compact cell-border nowrap stripe" id="depositorTable"
                            style="cursor: pointer;">
                            <table>
                              <tbody>
                                  <th>
                                    <button (click)="onAddRow()" *ngIf="addForm.get('rows')" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"><i class="fa fa-plus"></i>Add</button>
                                  </th>
                                  <tr *ngIf="showTable">
                                      <th>  <label class="form-control-label"> Remove:</label> </th>
                                      <th>  <label class="form-control-label">Type of Holding <span _ngcontent-c2=""style="color: red;">*</span></label></th>
                                      <th>  <label class="form-control-label">Allotment No./ Transfer No.</label></th>
                                      <th>  <label class="form-control-label">Date of allotment/ transfer</label></th>
                                      <th>  <label class="form-control-label">No. of debentures / other securities allotted/ transferred</label></th>
                                      <th>  <label class="form-control-label">Distinctive numbers (both inclusive)</label></th>
                                      <th>  <label class="form-control-label">Distinctive numbers (both inclusive)( From)</label></th>
                                      <th>  <label class="form-control-label">Distinctive numbers (both inclusive)( To)</label></th>
                                      <th>  <label class="form-control-label">Folio of transferor, if applicable</label></th>
                                      <th>  <label class="form-control-label">Name of the transferor, if applicable</label></th>
                                      <th>  <label class="form-control-label">Date of issue / endorsement of certificate</label></th>
                                      <th>  <label class="form-control-label">Certificate No.<span _ngcontent-c2=""style="color: red;">*</span></label></th>
                                      <th>  <label class="form-control-label">Lock in period, if any</label></th>
                                      <th>  <label class="form-control-label">Amount (Rs)</label></th>
                                      <th>  <label class="form-control-label">Amount (Rs)(Payable)</label></th>
                                      <th>  <label class="form-control-label">Amount (Rs)(Paid / Deemed to be paid)</label></th>
                                      <th>  <label class="form-control-label">Amount (Rs)(Due)</label></th>
                                      <th>  <label class="form-control-label">If debentures / other securities issued for consideration other than cash, brief particulars thereof</label></th>
                                      <th>  <label class="form-control-label"> Date of transfer/ transmission/ redemption forfeiture of securities</label></th>
                                      <th>  <label class="form-control-label"> No. of units transferred/ transmitted/ forfeited /redeemed</label></th>
                                      <th>  <label class="form-control-label"> Distinctive numbers (both inclusive) (transfer/ transmission/ redemption forfeiture of securities)</label></th>
                                      <th>  <label class="form-control-label"> Distinctive numbers (both inclusive) (transfer/ transmission/ redemption forfeiture of securities)(From)</label></th>
                                      <th>  <label class="form-control-label"> Distinctive numbers (both inclusive) (transfer/ transmission/ redemption forfeiture of securities)(To)</label></th>
                                      <th>  <label class="form-control-label"> Folio of transferee</label></th>
                                      <th>  <label class="form-control-label"> Name of transferee</label></th>
                                      <th>  <label class="form-control-label"> Balance units left (after transfer, transmission, redemption etc)</label></th>
                                      <th>  <label class="form-control-label"> Other remarks</label></th>
                                  </tr>
                                <tr *ngFor="let row of addForm.get('rows')?.controls; let j = index">
                                  <th>
                                    <button (click)="onRemoveRow(index)" class="btn btn-sm btn-primary mb-2"><span class="icmn-bin"></span>Remove</button>
                                  </th>
                                    <th>
                                      <select [formControl]="row.get('typeOfHolding')" style="padding:6px;">
                                        <option value="" [selected]="true">Select</option>
                                        <option value="allotment">Allotment</option>
                                        <option value="transfer">Transfer</option>
                                        <option value="transmission">Transmission</option>
                                        <option value="forfeiture">Forfeiture</option>
                                        <option value="redemption">Redemption</option>
                                      </select>
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('allotmentNumber')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('dateOfAllotment')">
                                    </th>
                                    <th>
                                          <input [formControl]="row.get('numberOfSecurities')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('distinctiveNumber')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('numberFrom')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('numberTo')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('folio')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('nameOfTransferor')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('dateOfIssue')">
                                    </th>
                                    <th>
                                          <input [formControl]="row.get('certificateNumber')">
                                    </th>
                                    <th>
                                          <input [formControl]="row.get('lock')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('amount')">
                                    </th>
                                    <th>
                                      <input [formControl]="row.get('amountPayable')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('amountPaid')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('amountDue')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('breifDebenture')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('dateOfTransfer')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('numberOfTransfer')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('distinctiveNumberTransfer')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('distinctiveNumberTransferFrom')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('distinctiveNumberTransferTo')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('folioTransferee')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('nameTransferee')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('balanceLeft')">
                                    </th>
                                    <th>
                                        <input [formControl]="row.get('otherRemarks')">
                                    </th>
                                </tr>
                              </tbody>
                            </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="form-group">
                    <button type="submit" class="btn btn-sm btn-primary" (click)="onSave(addForm)"><i class="fa fa-save"></i>Update</button>
                  </div>
                  <section class="card">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="margin-bottom-50">
                          <div class="table-responsive">
                            <table datatable [dtOptions]="dtTriggerDeposit" [dtTrigger]="dtTrigger"
                              class="table table-hover compact cell-border nowrap stripe" id="depositorTable"
                              style="cursor: pointer;">
                                 <thead>
                                <tr>
                                  <th>typeOfHolding</th>
                                  <th>allotmentNumber</th>
                                  <th>dateOfAllotment</th>
                                  <th>numberOfSecurities</th>
                                  <th>distinctiveNumber</th>
                                  <th>numberFrom</th>
                                  <th>numberTo</th>
                                  <th>folio</th>
                                  <th>nameOfTransferor</th>
                                  <th>dateOfIssue</th>
                                  <th>certificateNumber</th>
                                  <th>lock</th>
                                  <th>amount</th>
                                  <th>amountPayable</th>
                                  <th>amountPaid</th>
                                  <th>amountDue</th>
                                  <th>breifDebenture</th>
                                  <th>dateOfTransfer</th>
                                  <th>numberOfTransfer</th>
                                  <th>distinctiveNumberTransfer</th>
                                  <th>distinctiveNumberTransferFrom</th>
                                  <th>distinctiveNumberTransferTo</th>
                                  <th>folioTransferee</th>
                                  <th>nameTransferee</th>
                                  <th>balanceLeft</th>
                                  <th>otherRemarks </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let depositor of SecurityDetailList;let i=index">
                                  <td tabindex="1">{{depositor.typeOfHolding}}</td>
                                  <td tabindex="1">{{depositor.allotmentNumber}}</td>
                                  <td tabindex="1">{{depositor.dateOfAllotment}}</td>
                                  <td tabindex="1">{{depositor.numberOfSecurities}}</td>
                                  <td tabindex="1">{{depositor.distinctiveNumber}}</td>
                                  <td tabindex="1">{{depositor.numberFrom}}</td>
                                  <td tabindex="1">{{depositor.numberTo}}</td>
                                  <td tabindex="1">{{depositor.folio}}</td>
                                  <td tabindex="1">{{depositor.nameOfTransferor}}</td>
                                  <td tabindex="1">{{depositor.dateOfIssue}}</td>
                                  <td tabindex="1">{{depositor.certificateNumber}}</td>
                                  <td tabindex="1">{{depositor.lock}}</td>
                                  <td tabindex="1">{{depositor.amount}}</td>
                                  <td tabindex="1">{{depositor.amountPayable}}</td>
                                  <td tabindex="1">{{depositor.amountPaid}}</td>
                                  <td tabindex="1">{{depositor.amountDue}}</td>
                                  <td tabindex="1">{{depositor.breifDebenture}}</td>
                                  <td tabindex="1">{{depositor.dateOfTransfer}}</td>
                                  <td tabindex="1">{{depositor.numberOfTransfer}}</td>
                                  <td tabindex="1">{{depositor.distinctiveNumberTransfer}}</td>
                                  <td tabindex="1">{{depositor.distinctiveNumberTransferFrom}}</td>
                                  <td tabindex="1">{{depositor.distinctiveNumberTransferTo}}</td>
                                  <td tabindex="1">{{depositor.folioTransferee}}</td>
                                  <td tabindex="1">{{depositor.nameTransferee}}</td>
                                  <td tabindex="1">{{depositor.balanceLeft}}</td>
                                  <td tabindex="1">{{depositor.otherRemarks}}</td>
                                  <td style='white-space: nowrap'>
                                    <button class="btn btn-sm btn-primary mb-2" type="button" data-toggle="modal" class="btn-sm btn btn-warning"
                                      (click)="getDetailOfSecurity(depositor._id)" >
                                      <span class="fa fa-pencil"></span>
                                    </button>
                                  </td>
                                  <th>
                                    <button type="button" class="btn btn-sm btn-primary mb-2" class="btn-sm btn btn-danger"
                                      (click)="deletesecuritydetail(depositor._id)" >
                                      <span class="icmn-bin"></span>
                                    </button>
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </form>
             <table>
              <thead></thead>
              <tbody>
                <div class="modal fade" id="hello" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
                  aria-labelledby="" aria-hidden="true" style ="top: 150px;">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div id="hello1">
                          <section class="card">
                            <div class="row">
                              <div class="col-md-12">
                               
                                  <div class="table-responsive">
                                    <form [formGroup]="editForm" (ngSubmit)="onFormSubmit(editForm.value, depositor._id)">
                                      <tr>
                                        <th>typeOfHolding: <input placeholder={{depositor.typeOfHolding}}
                                        formControlName="dateOfDeposit">
                                      <span *ngIf="!editForm.get('typeOfHolding').valid && editForm.get('typeOfHolding').touched">Please enter
                                        value</span>
                                      </th>
                                        <th>allotmentNumber<input placeholder={{depositor.allotmentNumber}} formControlName="allotmentNumber">
                                      <span *ngIf="!editForm.get('allotmentNumber').valid && editForm.get('allotmentNumber').touched">Please enter
                                        value</span>
                                      </th>
                                        <th>dateOfAllotment <input placeholder={{depositor.dateOfAllotment}} formControlName="dateOfAllotment">
                                      <span *ngIf="!editForm.get('dateOfAllotment').valid && editForm.get('dateOfAllotment').touched">Please
                                        enter value</span>
                                      </th>
                                        <th>numberOfSecurities<input placeholder={{depositor.numberOfSecurities}} formControlName="numberOfSecurities">
                                      <span
                                        *ngIf="!editForm.get('numberOfSecurities').valid && editForm.get('numberOfSecurities').touched">Please
                                        enter value</span>
                                      </th>
                                        <th> distinctiveNumber<input placeholder={{depositor.distinctiveNumber}} formControlName="distinctiveNumber">
                                      <span *ngIf="!editForm.get('distinctiveNumber').valid && editForm.get('distinctiveNumber').touched">Please
                                        enter value</span>
                                      </th>
                                        <th>numberFrom<input placeholder={{depositor.numberFrom}} formControlName="numberFrom">
                                      <span *ngIf="!editForm.get('numberFrom').valid && editForm.get('numberFrom').touched">Please enter
                                        value</span>
                                      </th>
                                        <th>numberTo<input placeholder={{depositor.numberTo}} formControlName="numberTo">
                                      <span *ngIf="!editForm.get('numberTo').valid && editForm.get('numberTo').touched">Please enter
                                        value</span>
                                      </th>
                                        <th>folio<input placeholder={{depositor.folio}} formControlName="folio">
                                      <span *ngIf="!editForm.get('folio').valid && editForm.get('folio').touched">Please enter
                                        value</span>
                                      </th>
                                        <th> nameOfTransferor<input placeholder={{depositor.nameOfTransferor}} formControlName="nameOfTransferor">
                                      <span
                                        *ngIf="!editForm.get('nameOfTransferor').valid && editForm.get('nameOfTransferor').touched">Please
                                        enter value</span>
                                      </th>
                                        <th>dateOfIssue<input placeholder={{depositor.dateOfIssue}}
                                        formControlName="dateOfIssue">
                                      <span *ngIf="!editForm.get('dateOfIssue').valid && editForm.get('dateOfIssue').touched">Please
                                        enter value</span>
                                      </th>
                                        <th> certificateNumber<input placeholder={{depositor.certificateNumber}} formControlName="certificateNumber">
                                      <span *ngIf="!editForm.get('certificateNumber').valid && editForm.get('certificateNumber').touched">Please
                                        enter value</span>
                                      </th>
                                        <th> lock<input placeholder={{depositor.lock}}
                                        formControlName="lock">
                                      <span *ngIf="!editForm.get('lock').valid && editForm.get('lock').touched">Please
                                        enter value</span>
                                      </th>
                                        <th>amount<input placeholder={{depositor.amount}} formControlName="amount">
                                      <span
                                        *ngIf="!editForm.get('amount').valid && editForm.get('amount').touched">Please
                                        enter value</span>
                                        </th>
                                        <th>amountPayable<input placeholder={{depositor.amountPayable}} formControlName="amountPayable">
                                      <span
                                        *ngIf="!editForm.get('amountPayable').valid && editForm.get('amountPayable').touched">Please
                                        enter value</span>
                                      </th>
                                      <th>
                                            amountPaid<input placeholder={{depositor.amountPaid}} formControlName="amountPaid">
                                      <span
                                        *ngIf="!editForm.get('amountPaid').valid && editForm.get('amountPaid').touched">Please
                                        enter value</span>
                                      </th>
                                      <th>
                                          amountPaid<input placeholder={{depositor.amountPaid}} formControlName="amountPaid">
                                    <span
                                      *ngIf="!editForm.get('amountPaid').valid && editForm.get('amountPaid').touched">Please
                                      enter value</span>
                                    </th>
                                      <th>
                                          amountDue<input placeholder={{depositor.amountDue}} formControlName="amountDue">
                                        <span
                                          *ngIf="!editForm.get('amountDue').valid && editForm.get('amountDue').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          breifDebenture<input placeholder={{depositor.breifDebenture}} formControlName="breifDebenture">
                                        <span
                                          *ngIf="!editForm.get('breifDebenture').valid && editForm.get('breifDebenture').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          dateOfTransfer<input placeholder={{depositor.dateOfTransfer}} formControlName="dateOfTransfer">
                                        <span
                                          *ngIf="!editForm.get('dateOfTransfer').valid && editForm.get('dateOfTransfer').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          numberOfTransfer<input placeholder={{depositor.numberOfTransfer}} formControlName="numberOfTransfer">
                                        <span
                                          *ngIf="!editForm.get('numberOfTransfer').valid && editForm.get('numberOfTransfer').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          distinctiveNumberTransfer<input placeholder={{depositor.distinctiveNumberTransfer}} formControlName="distinctiveNumberTransfer">
                                        <span
                                          *ngIf="!editForm.get('distinctiveNumberTransfer').valid && editForm.get('distinctiveNumberTransfer').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          distinctiveNumberTransferFrom<input placeholder={{depositor.distinctiveNumberTransferFrom}} formControlName="distinctiveNumberTransferFrom">
                                        <span
                                          *ngIf="!editForm.get('distinctiveNumberTransferFrom').valid && editForm.get('distinctiveNumberTransferFrom').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>
                                          distinctiveNumberTransferTo<input placeholder={{depositor.distinctiveNumberTransferTo}} formControlName="distinctiveNumberTransferTo">
                                        <span
                                          *ngIf="!editForm.get('distinctiveNumberTransferTo').valid && editForm.get('distinctiveNumberTransferTo').touched">Please
                                          enter value</span>
                                      </th>
                                      <th>folioTransferee<input placeholder={{depositor.folioTransferee}} formControlName="folioTransferee">
                                      <span *ngIf="!editForm.get('folioTransferee').valid && editForm.get('folioTransferee').touched">Please enter value</span>
                                      </th>
                                      <th>nameTransferee<input placeholder={{depositor.nameTransferee}} formControlName="nameTransferee">
                                        <span *ngIf="!editForm.get('nameTransferee').valid && editForm.get('nameTransferee').touched">Please enter value</span>
                                      </th>
                                      <th>balanceLeft<input placeholder={{depositor.balanceLeft}} formControlName="balanceLeft">
                                        <span *ngIf="!editForm.get('balanceLeft').valid && editForm.get('balanceLeft').touched">Please enter value</span>
                                      </th>
                                      <th>otherRemarks<input placeholder={{depositor.otherRemarks}} formControlName="otherRemarks">
                                        <span *ngIf="!editForm.get('otherRemarks').valid && editForm.get('otherRemarks').touched">Please enter value</span>
                                      </th>
                                    </tr>
                                    <tr>
                                        <th><button type="submit" class="btn btn-sm btn-primary" [disabled]="!editForm.valid">save</button></th>
                                        <th><button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Close</button></th>
                                      </tr>
                                    </form>
                                  </div>
                                </div>
                              </div>
                          </section>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </tbody>
              </table>
        </div> -->
      
      </div>
    </div>
  </div>
</section>

